import { Route } from "react-router-dom";
import PlantInchargeDashboard from "../../screens/plant_incharge/PlantInchargeDashboard";
import PickupOrderList from "../../screens/plant_incharge/PickupOrderList";
import PickupOrderDetail from "../../screens/plant_incharge/PickupOrderDetail";

export const plantInchargeRoutes = [
  <Route
    key="plant-incharge-dashboard"
    path="/"
    element={<PlantInchargeDashboard />}
  />,
  <Route
    key="pickup-order-list"
    path="/pickup-order-list"
    element={<PickupOrderList />}
  />,
  <Route
    key="pickup-order-detail"
    path="/pickup-order-detail/:id"
    element={<PickupOrderDetail />}
  />,
];
